import React, { Component } from 'react'
import BigScreen from '../../components/big_screen/BigScreen'
import BigBox from '../../components/ad_types/BigBox'
import Helmet from 'react-helmet'
import { dataFetcher } from '../../utils/js/fetch_helpers'
import { formatDate } from './shared/js/utils'
import {
    wp_api_video_page,
    wp_api_video_slug,
    gallery_player_id,
    brightcove_account_id,
    sn_url,
} from './../../utils/js/endpoints'
import store from './../../store'

import './Videos.scss'
import Strip from './Strip'
import { withRouter } from 'react-router-dom'

class Videos extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            nowPlayingId: 0,
            videos: [],
            isFetching_videos: false,
            isError_videos: false,
            featured: {},
            isFetching_featured: false,
            isError_featured: false,
            updated_strips: false,
            fetching_strips: false,
            hidePlaceholder: false,
        }
    }

    clipsData = dataFetcher({
        key: 'videos',
        name: 'videos',
        responsePointer: 'data',
    })
    getClips = this.clipsData.fire
    cancelClips = this.clipsData.cancel

    featuredData = dataFetcher({
        key: 'featured',
        name: 'featured',
        responsePointer: 'data',
    })
    getFeatured = this.featuredData.fire
    cancelFeatured = this.featuredData.cancel

    componentDidMount() {
        this.getClips(wp_api_video_page, this.setFeaturedVideo)
        store.dispatch({
            type: 'ANALYTIC_EVENT_PAGE',
            naming: {
                sport: this.props.sport,
                league: this.props.league,
                page: 'videos',
                url: window.location.href || document.URL,
            },
        })
    }

    componentWillUnmount() {
        this.cancelClips()
        this.cancelFeatured()
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.setFeaturedVideo()
        }
    }

    getFeaturedCallback = () => {
        if (this.state.featured && this.state.nowPlayingId !== this.state.featured.bc_video_id) {
            this.setState({
                nowPlayingId: this.state.featured.bc_video_id,
            })

            this.updateStripPosition(this.state.featured.bc_video_id)
        }
    }

    setFeaturedVideo = () => {
        // Initial setup of featured video.
        if (this.state.videos.length > 0 && Object.keys(this.state.featured).length === 0) {
            let featured = this.state.videos[0]['clips'][0]
            this.setState({
                featured: featured,
                nowPlayingId: featured.bc_video_id,
            })
            this.updateStripPosition(featured.bc_video_id)
            this.setAdTargets(featured)
        }

        let path = this.props.history.location.pathname
        if (path[path.length - 1] !== '/') {
            path += '/'
        }
        // eslint-disable-next-line
        let slug = path.match(/([^\/]*)\/*$/)[1]
        let featured_slug = this.state.featured ? this.state.featured.post_name : ''

        if (slug !== null && slug !== featured_slug && 'videos' !== slug) {
            let strips = this.state.videos
            let featured = {}

            // Look for video data in existing clips:
            for (var i = strips.length - 1; i >= 0; i--) {
                let clips = strips[i].clips

                for (var k = clips.length - 1; k >= 0; k--) {
                    if (clips[k].post_name === slug) {
                        featured = clips[k]
                    }
                }
            }

            // Try to get video data from WP.
            if (featured.ID == null) {
                this.getFeatured(wp_api_video_slug + slug, this.getFeaturedCallback)
            }

            if (featured.ID !== null) {
                this.setState({
                    nowPlayingId: featured.bc_video_id,
                    featured: featured,
                })
                this.setAdTargets(featured)
                this.updateStripPosition(featured.bc_video_id)
            }
        }
    }

    setAdTargets(post) {
        var articleMetaData = {}
        var ID = post.ID
        articleMetaData = {
            section: 'videos',
            page: 'videos',
            ad_unit_path: window.adUtility ? window.adUtility.adPath : '/7326/en.sportsnet.web',
        }
        articleMetaData['PostID'] = String(ID)
        articleMetaData['Tags'] = post.tags
        articleMetaData['sports'] = post.sport
        articleMetaData['leagues'] = post.league
        articleMetaData['Author'] = post.author
        articleMetaData['video-categories'] = post.categories
        return articleMetaData
    }

    updateStripPosition(video_id) {
        if (video_id == null) {
            return
        }

        // Remove active class.
        if (document.getElementsByClassName('active').length !== 0) {
            let active = document.getElementsByClassName('active')
            active[0].classList.remove('active')
        }

        let in_strip = document.querySelector('.clip[data-video-id="' + video_id + '"]')
        if (in_strip !== null && in_strip.length !== 0) {
            in_strip.classList.add('active')

            // Scroll strip to active video.
            let offset = in_strip.offsetLeft
            let parent = in_strip.parentElement
            parent.scrollLeft = offset
        }
    }

    irisCallback = data => {
        // Remove active clip.
        if (document.getElementsByClassName('active').length !== 0) {
            let active = document.getElementsByClassName('active')
            active[0].classList.remove('active')
        }
        // Here we can't rely on state, as we're keeping old instance of BigScreen.
        document.getElementById('featured-title').textContent = data.name
        document.getElementById('featured-summary').textContent = data.description
        document.getElementById('featured-date').textContent = formatDate(data.publishedAt)

        let duration = 0
        if (data.duration > 0) {
            let mm = Math.floor(data.duration / 60)
            data.duration -= mm * 60
            let ss = Math.floor(data.duration)

            if (ss < 10) {
                ss = '0' + ss
            }

            duration = mm + ':' + ss
        }
        document.getElementById('featured-duration').textContent = duration
    }

    handleClick = e => {
        this.stripsCallback()
        if (!e) return

        let video = e.target.closest('.clip')
        let video_id = video.getAttribute('data-video-id')

        if (video_id) {
            this.props.history.push('/videos' + video.getAttribute('data-url'))
            this.setFeaturedVideo()
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    updateStrips = () => {
        this.setState({
            updated_strips: true,
            fetching_strips: false,
        })
        setTimeout(this.setState({ hidePlaceholder: true }), 2000)
    }

    stripsCallback = () => {
        if (!this.state.updated_strips && !this.state.fetching_strips) {
            this.setState({
                fetching_strips: true,
            })

            this.getClips(wp_api_video_page + '?all=1', this.updateStrips())
        }
    }

    partInViewport = el => {
        if (el.length === 0) return false
        const top = el.getBoundingClientRect().top

        return top <= window.innerHeight
    }

    render() {
        let featured = this.state.featured
        if (featured != null && featured['post_date']) {
            featured['date'] = formatDate(featured['post_date'].replace(/-/g, '/'))
            var targets = this.setAdTargets(featured)
            window.adTargets = function() {
                return targets
            }
            store.dispatch({
                type: 'INIT_HEADER_LEADERBOARD_AD',
                targeting: targets,
            })
        }

        document.addEventListener('scroll', () => {
            let el = document.getElementById('placeholder')

            if (el && this.partInViewport(el)) {
                this.stripsCallback()
            }
        })

        return (
            <div>
                <link
                    href={`${sn_url}/wp-content/themes/sportsnet-nhl/brightcove.css`}
                    rel="stylesheet"
                />
                <div className="Videos__cont">
                    <div>
                        {featured.ID && !this.state.isFetching_featured && (
                            <div>
                                <Helmet
                                    title={
                                        featured['post_title']
                                            ? featured['post_title'].replace('&amp;', '&') +
                                              ' - Sportsnet Video'
                                            : 'Sportsnet Video'
                                    }
                                    link={[
                                        {
                                            rel: 'canonical',
                                            href: `${window.location.origin}/videos`,
                                        },
                                    ]}
                                />
                                <div className="featured-video">
                                    <div className="col-xlg-9 col-lg-9 col-md-8 col-sm-12 col-xs-12">
                                        <div id="sponsor-large">
                                            {featured.ID &&
                                                window.adUtility &&
                                                window.adUtility.insertAd('sponsor-large', {
                                                    type: window.adUtility._AD_BIGBUTTON,
                                                    adPath: window.adUtility.adPath,
                                                    targeting: window.adTargets(),
                                                })}
                                        </div>
                                        <div className="clearfix" />
                                        <div
                                            className={
                                                'video__cont' +
                                                (this.state.featured.league === 'nhl'
                                                    ? ' share-controls'
                                                    : '')
                                            }
                                        >
                                            {!this.state.loading && (
                                                <BigScreen
                                                    playerId={'SNPlayer'}
                                                    accountId={brightcove_account_id}
                                                    nowPlayingId={this.state.nowPlayingId}
                                                    video_title={featured['post_title']}
                                                    brightcovePlayerId={gallery_player_id}
                                                    useIrisControls={true}
                                                    irisCallback={this.irisCallback}
                                                    autoplay={true}
                                                    video_origin="video-hub"
                                                />
                                            )}
                                            <div className="recap__loading" />
                                        </div>
                                    </div>
                                    <div className="col-xlg-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 video-info">
                                        <h1 id="featured-title">
                                            {featured['post_title']
                                                ? featured['post_title'].replace('&amp;', '&')
                                                : ''}
                                        </h1>
                                        <div className="tands-date" id="main-date">
                                            <span id="featured-duration">
                                                {featured['video_duration']}
                                            </span>{' '}
                                            | <span id="featured-date">{featured['date']}</span>
                                        </div>
                                        <div className="summary" id="featured-summary">
                                            {featured['post_excerpt']}
                                        </div>
                                        <div className="bigbox" id="bigbox_ad_00">
                                            {featured.ID && !this.state.isFetching_featured && (
                                                <BigBox
                                                    bg={false}
                                                    view={'all'}
                                                    visible={true}
                                                    refresh={false}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="clearfix" />
                        <div>
                            {this.state.videos.map((strip, i) => {
                                return (
                                    <Strip
                                        clips={strip}
                                        title={strip.title}
                                        key={'strip-' + i}
                                        handleClick={this.handleClick}
                                    />
                                )
                            })}
                        </div>
                        {!this.state.hidePlaceholder && <div id="placeholder" />}
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(Videos)
